module.exports = __webpack_public_path__ + "img/yandex.e8b039e6.svg";